import game from './game'
import resource from './resource'
import sequenceManager from '../workbench/sequence'
import animation from '../workbench/animation/index'
import sceneManager from '../workbench/scene'
import rightPane from '../workbench/right-pane'
import language from '../workbench/language'
import resourceManager from '../workbench/resource-manager/index'
import layoutEditor from '../workbench/layout-editor/index'
import park from '../workbench/park/index'
import editorConfig from '../workbench/editor-config'
import globalConfig from '../workbench/global-config'
import gameConfig from '../workbench/game-config'
import project from '../workbench/project'
import globalVar from '../workbench/global-var'
import actionHistory from '../workbench/history'
import stage from '../workbench/stage'
import particle from './particle'
import store from '@ps/store'
import storyboard from '../workbench/storyboard'
import copyPaste from '../workbench/copy-paste'
import styleTab from '../workbench/style-tab'
import { workbenchRoute } from '@ps/router/config'
import initFormParam from '../workbench/selfDev/initFormParam'
import mask from '../workbench/mask/index'
import puzzle from '../workbench/puzzle/index'
import shelves from '../workbench/shelves/index'

const { assetTypes, pageModes } = workbenchRoute

const workspace = {
  namespaced: true,

  state: {
    pid: 0, // 项目 id
    assetId: 0, // 资源 id
    assetType: '', // 资源类型
    newResource: false, // 是否新资源库
    isPageLock: false,
    pageMode: pageModes.editProject, // 'edit-project' | 'edit-prefab'
    isEditPrefab: false,
    currentModule: '', // 当前操作模块，鼠标悬停时所处于的模块, 当前模块含有 sketchpad-manger, layer-manger, right-sidebar, scene-manger, nav-manager
    hasForbiddenFont: true, // 是否有下架的字体
    forbiddenFontList: {}, // 下架字体数据
  },

  getters: {
    hasBgm(state) {
      return Boolean(state.editorConfig.bgm.value)
    },

    hasBg(state) {
      return Boolean(state.editorConfig.bg.value)
    },
  },

  mutations: {
    updatePid(state, value) {
      state.pid = Number(value)
    },

    updateAssetId(state, value) {
      state.assetId = Number(value)
    },

    updateAssetType(state, value) {
      state.assetType = value
    },
    updateNewResource(state, value) {
      state.newResource = Boolean(value)
    },

    lockPage(state) {
      state.isPageLock = true
    },

    unlockPage(state) {
      state.isPageLock = false
    },

    updateCurrentModule(state, value) {
      state.currentModule = value
    },
    updateHasForbiddenFont(state, value) {
      state.hasForbiddenFont = value
    },
    updateForbiddenFontList(state, value) {
      state.forbiddenFontList = value
    },
  },

  actions: {
    // 添加预设，如果 URL 上有预设 id 和预设类型，则认为这是编辑预设状态
    async addPrefabFromUrl({ dispatch, state }) {
      if (state.assetId && store.state.user.info.is_internal_account) {
        const workspaceState = store.state.workspace
        state.pageMode = pageModes.editPrefab
        state.isEditPrefab = true
        if (state.assetType === assetTypes.particle) {
          return dispatch('game/addParticle', {
            id: state.assetId,
            resSource: 'common',
            from:
              workspaceState.pid === 10000 && !workspaceState.newResource
                ? 1
                : 2,
          })
        }
        if (state.assetType === assetTypes.scene) {
          // add scene
          return dispatch('game/sceneManager/addSceneByPrefab', {
            id: state.assetId,
            resSource: 'common',
          })
        }
        if (state.assetType === assetTypes.dragonBone) {
          const res = await store.dispatch(
            'workspace/resourceManager/readComponent',
            { id: state.assetId, resSource: 'common' },
          )
          return store.dispatch('workspace/game/addDragonBone', {
            data: res.data,
          })
        }
      }
    },
  },

  modules: {
    globalConfig,
    game,
    resource,
    sequenceManager,
    sceneManager,
    rightPane,
    language,
    resourceManager,
    editorConfig,
    project,
    actionHistory,
    stage,
    particle,
    storyboard,
    animation,
    copyPaste,
    styleTab,
    globalVar,
    layoutEditor,
    gameConfig,
    initFormParam,
    park,
    mask,
    puzzle,
    shelves,
  },
}

export default workspace
